<template>
	<div class="div_home_zhiku">
		<div class="subTop1">
		  <em>Collaborating Experts</em>
		  <span>中经智库</span>
		  <div v-if="showtype=='专家'" class="arrow">
		    <i class="arrow-left" :class="showpage<1?'arr-disable':''" @click="pre()"></i>
		    <i class="arrow-right" :class="showpage>=(maxpage-1)?'arr-disable':''" @click="next()"></i>
		  </div>
		</div>
		<div style="margin: 24px 0px;">
			<el-radio-group v-model="showtype" @input="showtypechange">
				<el-radio-button label="合作机构"></el-radio-button>
				<el-radio-button label="专家"></el-radio-button>
			</el-radio-group>
		</div>
		<dl v-if="showtype=='合作机构'" class="zhiku_jigou">
			<dd v-for="(item,index) in zuzhijigouList" v-if="index>=(showpage*3)&&index<((showpage+1)*3)">
				<div class="pic">
					<img :src="item.image" />
				</div>
				<div  class="list">
					<div style="position: relative;">
						<p style="font-size: 18px;">{{item.title}}</p>
						<p class="zhiku_intro" >{{item.intro.length>80?item.intro.substring(0,80)+'...':item.intro}}</p>
						<span>{{item.intro}}</span>
					</div>
				</div>
			</dd>
		</dl>
		<dl v-if="showtype=='专家'" class="zhiku_zhuanjia">
			<dd v-for="(item,index) in zhuanjiaList" v-if="index>=(showpage*3)&&index<((showpage+1)*3)">
				<div class="pic">
					<img :src="item.image" />
				</div>
				<div  class="list">
					<div style="position: relative;">
						<p style="font-size: 18px;">{{item.title}}</p>
						<p class="zhiku_intro" >{{item.intro.length>80?item.intro.substring(0,80)+'...':item.intro}}</p>
						<span>{{item.intro}}</span>
					</div>
				</div>
			</dd>
		</dl>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isloading:true,
				showtype:'合作机构',
				showpage:0,
				maxpage:1,
				zuzhijigouList:[
					{
						title:'北京工商大学数字经济研究院',
						intro:'成立于2019年12月，致力打造政产学研用深度融合的新型智库平台。承担完成国务院研究室、国家发改委、国家互联网信息中心等机构委托课题近20项研究任务。在数字经济、数字货币、信息化建设等方面提供高水平研究成果。',
						image:'/images/zuzhijigou1.png'
					},
					{
						title:'北京国际大数据交易所',
						intro:'贯彻北京市“国家服务业扩大开放综合示范区”和“中国（北京）自由贸易试验区”建设的标杆性重点项目。探索建立集数据登记、评估、共享、交易、应用、服务于一体的数据流通机制，打造国内领先的数据交易基础设施和国际重要的数据跨境交易枢纽。',
						image:'/images/zuzhijigou2.png'
					},
					{
						title:'招标网',
						intro:'隶属于北京中招国联科技有限公司，致力于为企业提供招标、采购、拟在建项目信息及网上招标采购等一系列商务服务。招标网是招标采购领域的资讯和交易网站，为各级政府采购、招标代理机构、招标企业、供应商提供强大的专业招标采购信息查询和相关服务。',
						image:'/images/zuzhijigou3.png'
					},
					
				],
				zhuanjiaList:[
					{
						title:'杨学山',
						intro:'工业和信息化部原副部长、党组成员。研究汉字信息处理，信息系统和网络的设计和开发，信息经济学，信息法学，国家信息化发展战略。著有《专家系统及其在管理中的应用》，《知识经济时代的企业技术创新和改造》、《企业信息化建设与管理》等专著。',
						image:'/images/zhuanjia01.png'
					},
					{
						title:'李德文',
						intro:'曾任工业和信息化部网络安全产业发展中心（工业和信息化部信息中心）副主任等职务，承担工信部、发改委、商务部等多项重大课题。',
						image:'/images/zhuanjia02.png'
					},
					{
						title:'朱幼平',
						intro:'北京大学经济学硕士，加拿大工商研究院和维多利亚大学访问学者；国家信息中心研究员，曾荣获原国家计委科技进步三等奖、国家信息中心研究成果二等奖等荣誉；著名行业研究专家，在宏观经济分析、市场调研、行业与信息系统研究等方面著述丰硕，具有相当的社会影响。',
						image:'/images/zhuanjia03.png'
					},
					{
						title:'葛红玲',
						intro:'北京工商大学教授，硕士生导师，中国人民大学博士研究生毕业，曾在清华大学做高级访问学者。长期从事金融学教学和科研工作，为本科生主讲“证券投资学”、“金融信托与租赁”、“金融学”等课程； 为研究生主讲“资产证券化”、“公司金融”、“资本市场” 课程。',
						image:'/images/zhuanjia04.png'
					},
					{
						title:'李正波',
						intro:'商务部中国国际电子商务中心首席分析师以及数字商务研究部负责人，多次承担商务部课题项目，所撰写文章多次受到相关领导批示。',
						image:'/images/zhuanjia05.png'
					},
					{
						title:'杨春立',
						intro:'清华大学工业工程博士后，中国电子信息产业发展研究院中国软件评测中心副主任。承担国家工业互联网监测分析公共服务平台建设，承担多个省市十二五、十三五信息化发展规划编制、智慧城市顶层设计和数字经济规划编制。现担任全国两化融合技术标准委员会委员。',
						image:'/images/zhuanjia06.png'
					},
					{
						title:'徐斌',
						intro:'经济学博士、管理科学与工程博士后、教授、博士生导师、博士后导师。江西财经大学智库建设中心主任、现代产业发展研究院院长。获第六、七届薛暮桥价格奖、江西省社科成果二、三等奖。主要研究方向为数字经济、资源管理、区域创新与产业发展等。',
						image:'/images/zhuanjia07.png'
					},
					{
						title:'胡麒牧',
						intro:'中国人民大学经济学博士，华侨大学兼职教授，北京航空航天大学MBA校外导师，数字经济智库首席研究员。在光明日报、经济日报等报纸刊物撰写宏观经济、数字经济、大宗商品领域数十篇评论文章。担任央视新闻频道、财经频道等特约评论员。',
						image:'/images/zhuanjia08.png'
					},
					{
						title:'尚进',
						intro:'中国信息协会专家办主任，中国信息界杂志社社长、执行总编辑，中国信息界发展研究院院长，北京大学智慧城市研究中心研究员',
						image:'/images/zhuanjia09.png'
					},
				],
			}
		},
		created:function(){
			// this.yuntufnc();
		},
		components:{
			
		},
		mounted:function(){
			this.showtypechange('合作机构');
		},
		methods: {
			showLogin: function() {
				this.$emit('showLogin');
			},
			showtypechange:function(label){
				// console.log(label);
				this.showpage=0;
				if(label=='合作机构'){
					this.maxpage=Math.ceil(this.zuzhijigouList.length/3);
				}
				else if(label=='专家'){
					this.maxpage=Math.ceil(this.zhuanjiaList.length/3);
				}
				else{
					this.maxpage=1;
				}
			},
			pre:function(){
				if(this.showpage>0){
					this.showpage--;
				}
				else{
					this.showpage=this.maxpage-1;
				}
			},
			next:function(){
				if(this.showpage<(this.maxpage-1)){
					this.showpage++;
				}
				else{
					this.showpage=0;
				}
			},
		}
	}
</script>

<style>
</style>
